import { render, staticRenderFns } from "./AuthorAffairListItem.vue?vue&type=template&id=288300b1&"
import script from "./AuthorAffairListItem.vue?vue&type=script&lang=js&"
export * from "./AuthorAffairListItem.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAffairListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports